import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VFileInput, {
    attrs: {
      "show-size": "",
      "counter": "",
      "multiple": "",
      "accept": "image/jpg, image/jpeg, image/png",
      "rules": [v => !(_vm.sum(v) > _vm.bytes) || _vm.$i18n_t('Common.help.imagesSize')],
      "label": _vm.$i18n_t('Common.help.screenshot')
    },
    on: {
      "change": _vm.handleFileUpload,
      "click:clear": _vm.clear
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function ({
        text,
        index
      }) {
        return [_c(VChip, {
          attrs: {
            "color": _vm.color,
            "small": "",
            "close": "",
            "label": ""
          },
          on: {
            "click:close": function ($event) {
              return _vm.deleteFromList(index);
            }
          }
        }, [_vm._v("\n            " + _vm._s(text) + "\n          ")])];
      }
    }]),
    model: {
      value: _vm.files,
      callback: function ($$v) {
        _vm.files = $$v;
      },
      expression: "files"
    }
  })], 1), _vm.urls.length ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, _vm._l(_vm.urls, function (url, key) {
    return _c(VCol, {
      key: key,
      attrs: {
        "sm": "2",
        "xs": "2",
        "md": "2"
      }
    }, [_c(VAvatar, {
      attrs: {
        "size": "70",
        "tile": ""
      }
    }, [_c(VImg, {
      attrs: {
        "aspect-ratio": 1,
        "src": url,
        "alt": _vm.files[key].name
      }
    })], 1)], 1);
  }), 1)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };